import { onShopifySectionLoad, ready } from '../global/instantiate';
import { initResponsiveVideo } from '../sections/hero';

ready(() => {
  initResponsiveVideo();
});

onShopifySectionLoad(() => {
  initResponsiveVideo();
});